/**
 * Payment adapter factory.
 * Apple IAP is the only payment path (Stripe has been removed). Purchases are
 * available in the native iOS app; on web the adapter has no purchasable
 * products and upgrade actions are unavailable by design.
 */
let adapterInstance = null;

export async function createPaymentAdapter() {
  if (adapterInstance) return adapterInstance;

  const { IAPAdapter } = await import('./IAPAdapter');
  adapterInstance = new IAPAdapter();

  await adapterInstance.initialize();
  return adapterInstance;
}

export function getPaymentAdapter() {
  return adapterInstance;
}
